export default "__VITE_ASSET__B9w5MrAZ__"